// Tour step properties:
//   - aboveDrawer: (bool) step targets an element inside a drawer overlay — adjusts z-index accordingly
//   - awaitClick: (string) CSS selector — the tour pauses until the user clicks this element
//   - awaitClickAdvanceDelay: (number) ms to wait after the click before moving to the next step
//   - awaitClickAll: (bool) listen for click on ALL elements matching awaitClick, not just the first
//   - awaitClickDelegate: (bool) use event delegation for awaitClick — resilient to DOM re-renders (e.g. FullCalendar)
//   - awaitClickLast: (bool) target the last matching element and block clicks on all others
//   - blockClickOnlySelectors: (string[]) CSS selectors whose click events are blocked (mousedown allowed for drag-and-drop)
//   - blockClickSelectors: (string[]) CSS selectors whose click AND mousedown events are blocked
//   - blockTarget: (bool|string) true = block clicks on the spotlight target; string = block clicks on that selector
//   - blockTargetException: (string|string[]) inside a blocked target, these selectors stay clickable
//   - blockTargetSiblings: (bool) block all siblings inside the target container, only the awaitClick element stays clickable
//   - congrats: (bool) marks the final congratulatory step (triggers confetti)
//   - content: (string) i18n key for the step body text
//   - hideFinish: (bool) hide the Finish button (used when chaining to another tour)
//   - hidePrev: (bool) hide the Previous button for this step
//   - highlightDays: (bool) add a pulsing highlight to calendar day cells
//   - nextTour: (string) id of the tour to start when this step or tour ends (chaining)
//   - noSpotlight: (bool) disable the spotlight cutout (full overlay, e.g. for congrats)
//   - position: (string) tooltip placement relative to the target — top | bottom | left | right | center
//   - pulse: (bool) show a pulsing animation on the awaitClick element (default: true when awaitClick is set)
//   - raiseAncestors: (bool) raise ancestor stacking contexts so the target escapes its parent z-index
//   - scrollTo: (string) 'top' scrolls the page to top instead of centering the target
//   - spotlightPadding: (number) extra px around the target in the spotlight cutout
//   - target: (string) CSS selector of the element to highlight
//   - title: (string) i18n key for the step title
//   - watchTargets: (string[]) extra CSS selectors included in the spotlight area

export default {
  id: 'pages',
  route: 'pages',
  steps: [
    // --- Step 1: Overview of the pages section ---
    {
      target: '.section-pages',
      title: 'tours.pages.steps.overview.title',
      content: 'tours.pages.steps.overview.content',
      position: 'center',
      spotlightPadding: 80,
      blockTarget: true,
      blockOutsideSpotlight: true
    },
    // --- Step 2: Connect a new account button ---
    {
      target: '.section-pages .vs-col > .btn-large.btn-img',
      title: 'tours.pages.steps.connectButton.title',
      content: 'tours.pages.steps.connectButton.content',
      position: 'bottom',
      spotlightPadding: 8,
      blockTarget: true,
      blockOutsideSpotlight: true
    },
    // --- Step 3: Add Group ---
    {
      target: '.section-pages .btn-large:not(.btn-img)',
      title: 'tours.pages.steps.addGroup.title',
      content: 'tours.pages.steps.addGroup.content',
      position: 'bottom',
      spotlightPadding: 8,
      blockTarget: true,
      skipIfMissing: true,
      blockOutsideSpotlight: true
    },
    // --- Step 4: Pages list ---
    {
      target: '.section-pages .pages-content',
      title: 'tours.pages.steps.pagesList.title',
      content: 'tours.pages.steps.pagesList.content',
      position: 'center',
      spotlightPadding: 20,
      blockTarget: true,
      blockOutsideSpotlight: true
    },
    // --- Congrats ---
    {
      title: 'tours.pages.steps.congrats.title',
      content: 'tours.pages.steps.congrats.content',
      position: 'center',
      noSpotlight: true,
      congrats: true,
      hideFinish: true,
      nextTour: 'settings',
      blockOutsideSpotlight: true
    }
  ]
}
